// Generated by genversion.
export const name = 'sibelga-mixer-web-frontend';
export const version = '1.1.0';
